module.exports = __webpack_public_path__ + "img/symbol_heart.5fed8493.png";